export enum LocaleType {
  LT = 'LT',
  EN = 'EN',
  CS = 'CS',
  DE = 'DE',
  ES = 'ES',
  FR = 'FR',
  IT = 'IT',
}
